module.exports = __webpack_public_path__ + "img/type-ico.b1cca6d4.svg";